﻿

/**
 * @description Service for purchasing agreement
 */
export const PurchasingAgreementService = function () {
	var baseUrl = '/api/agreement/';
	const BASE_URL_FIXED_PRICE_AGREEMENT = '/api/fixed-price-agreement/';
	this.getGrainTypes = function (agreementType, priceAreaId, productItemId) {
		return $.ajax({
			dataType: 'json',
			type: 'get',
			url: baseUrl + 'get-grain-type',
			data: {
				priceAreaId: priceAreaId,
				productItemId: productItemId,
				agreementType: agreementType,
			},
			cache: false,
		});
	};

	/**
	 * Fixed price agreement Groups
	 * @param {string} articleId
	 * @param {string} customerNumber
	 */
	this.getFixedPriceAgreementBasePrice = function (articleId, customerNumber) {
		return $.ajax({
			dataType: 'json',
			type: 'get',
			url: BASE_URL_FIXED_PRICE_AGREEMENT + 'base-price',
			data: {
				articleId: articleId,
				customerNumber: customerNumber,
			},
			cache: false,
		});
	};

	/**
	 * Fixed price agreement Groups
	 * @param {any} groupid
	 */
	this.getFixedPriceAgreementGroups = function (groupid) {
		return $.ajax({
			dataType: 'json',
			type: 'get',
			url: BASE_URL_FIXED_PRICE_AGREEMENT + 'article-groups',
			data: 'categoryId=' + groupid.data,
			cache: false,
		});
	};

	/**
	 * Fixed price agreement Items
	 * @param {any} agreementType
	 * @param {any} itemid
	 */
	this.getFixedPriceAgreementItems = function (itemid) {
		return $.ajax({
			dataType: 'json',
			type: 'get',
			url: BASE_URL_FIXED_PRICE_AGREEMENT + 'articles',
			data: 'articleGroupId=' + itemid.data,
			cache: false,
		});
	};

	/**
	 * Check if a specific fixed price agreement already exists based on the fixed price agreement number
	 * @param {any} callOffAgreementNumber
	 */
	this.checkIfFixedPriceAgreementExists = function (callOffAgreementNumber) {
		return $.ajax({
			dataType: 'json',
			type: 'get',
			url: BASE_URL_FIXED_PRICE_AGREEMENT + 'check-if-fixed-price-agreement-exists',
			data: { callOffAgreementNumber },
			cache: false,
		});
	};

	this.getProtectAgreement = function (agreementId, productItemId, priceAreaId, grainType) {
		if (!agreementId) {
			console.warn('Missing agreementId');
			return;
		}

		return $.ajax({
			dataType: 'json',
			type: 'get',
			url: baseUrl + 'get-grain-price-periods-storage/',
			data: { priceAreaId: priceAreaId, productItemId: productItemId, grainType: grainType },
			cache: false,
		});
	};

	this.getGrainTypesForSpotAgreement = function (priceAreaId, productItemId) {
		return $.ajax({
			dataType: 'json',
			type: 'get',
			url: baseUrl + 'get-grain-type-spot-agreement',
			data: { priceAreaId: priceAreaId, productItemId: productItemId },
			cache: false,
		});
	};

	this.getSpotAndForwarPriceListForGrainType = function (priceAreaId, productItemId, grainType) {
		return $.ajax({
			dataType: 'json',
			type: 'get',
			url: baseUrl + 'get-grain-price-periods/',
			data: { priceAreaId: priceAreaId, productItemId: productItemId, grainType: grainType },
			cache: false,
		});
	};

	this.sendForDigitalSigning = function (data) {
		return $.ajax({
			url: baseUrl + 'send-for-digital-signing',
			method: 'post',
			data: data,
		});
	};

	this.saveAgreement = function (data) {
		const FIXED_PRICE_AGREEMENT = 'FastPrisAvtalFoder';

		// handle fixed price agreement
		if (data[0].value === FIXED_PRICE_AGREEMENT) {
			return this.saveFixedPriceAgreement(data);
		}

		return $.ajax({
			url: baseUrl + 'save',
			method: 'post',
			data: data,
		});
	};

	this.saveFixedPriceAgreement = function (data) {
		data = this.mapToSaveFixedPriceAgreementRequestObject(data)
		const url = '/api/fixed-price-agreement/save';

		return $.ajax({
			url,
			contentType: 'application/json',
			method: 'post',
			data: JSON.stringify(data),
		});
	};

	this.getReceiversForDigitalSigning = function () {
		return $.ajax({
			url: baseUrl + 'get-receivers-for-digital-signing',
			dataType: 'json',
			type: 'get',
		});
	};

	this.convertArrayToObject = function (data){
		let retObj = {};

		data.forEach(item => {
			retObj[item.name] = item.value;
		});

		return retObj;
	};

	// Mapping the data for Fixed price agreement
	this.mapToSaveFixedPriceAgreementRequestObject = function (data) {
		data = this.convertArrayToObject(data);
		const retObj = {
			agreementType: data.AgreementType,
			receiverName: data.ReceiverName,
			receiverEmail: data.ReceiverEmail,
			receiverMobilePhoneNumber: data.ReceiverMobilePhoneNumber,
			receiverPersonalNumber: data.ReceiverPersonalNumber,
			fromDate: data.FromDate,
			endDate: data.EndDate,
			customerNumber: data.customerNumberElementName,
			customerName: data.ReceiverName,
			callOffAgreementNr: data.CallOffAgreementNr,
			designation: data.Designation,
			agreementsLines: JSON.parse(data.AgreementsLines).map((article) => {

				return {
					articleNr: article.articleNr,
					quantity: article.CommitQuantity,
					unit: 'Ton',
					price: article.defaultPrice,
					termSupplement: article.termSupplement,
					discountPerUnit: article.manualDiscount,
				};
			}),
		};
		return retObj;
	};
};
